type ComputeTotalStepsArgs = {
  hasMostRecentCreditCard: boolean
  isExtendBrand: boolean
  enableStepFourFullScreen: boolean
}

export const computeTotalSteps = ({
  hasMostRecentCreditCard,
  isExtendBrand,
  enableStepFourFullScreen,
}: ComputeTotalStepsArgs): number => {
  if (hasMostRecentCreditCard) return 2
  if (isExtendBrand && enableStepFourFullScreen) return 4
  return 3
}

type ShouldAdvanceArgs = {
  isExtendBrand: boolean
  enableStepFourFullScreen: boolean
}

export const shouldAdvanceToStepFour = ({
  isExtendBrand,
  enableStepFourFullScreen,
}: ShouldAdvanceArgs): boolean => isExtendBrand && enableStepFourFullScreen
